import { cn } from "utils/helpers";
import { formatCurrency } from "./utils";
import type { QuoteTableColumn } from "./quote-table.types";
import { CELL_BORDER, COLUMN_STYLE } from "./quote-table.types";

export interface QuoteTableTotalsRowProps {
	columns: QuoteTableColumn[];
	columnTotals: Record<number, number>;
	showActionsColumn?: boolean;
	showIndexColumn?: boolean;
	showZeroColumn?: boolean;
}

const QuoteTableTotalsRow: React.FC<QuoteTableTotalsRowProps> = ({
	columns,
	columnTotals,
	showActionsColumn = false,
	showIndexColumn = true,
	showZeroColumn = false,
}) => {
	const sorted = [...columns].sort((a, b) => a.sortOrder - b.sortOrder);
	const primaryDescriptionColId = sorted.find((c) => c.columnType === "description")?.id ?? null;

	return (
		<tfoot>
			<tr className="border-t-2 border-[#EAECF0] bg-gray-50 ">
				{showZeroColumn && (
					<td className={cn(CELL_BORDER, "bg-gray-100")} style={{ width: "5%" }} />
				)}
				{showIndexColumn && (
					<td
						className={cn(CELL_BORDER, "text-center font-roboto text-xs font-semibold text-gray-600 bg-gray-100")}
						style={{ height: "35px" }}
					>
						&Sigma;
					</td>
				)}
				{sorted.map((col) => {
					const isValueCol =
						(col.columnType === "response_value" || col.columnType === "saving") &&
						columnTotals[col.id] !== undefined;
					// Saving subtotals are discounts — render in red.
					const isSavingCol = col.columnType === "saving";
					return (
						<td
							key={`totals-${col.id}`}
							className={cn(
								CELL_BORDER,
								COLUMN_STYLE,
								"font-semibold bg-gray-100",
								isSavingCol ? "text-red-600" : "text-gray-800",
								isValueCol && "text-right pr-4"
							)}
						>
							{isValueCol
								? formatCurrency(columnTotals[col.id])
								: col.columnType === "description" && col.id === primaryDescriptionColId
									? <span className="font-semibold text-gray-600">Totals</span>
									: null
							}
						</td>
					);
				})}
				{showActionsColumn && (
					<td
						className={cn(CELL_BORDER, "bg-gray-100")}
						style={{ width: "40px" }}
					/>
				)}
			</tr>
		</tfoot>
	);
};

export { QuoteTableTotalsRow };
